/**
 * Versão em vigor dos Termos de Serviço e da Política de Privacidade
 * (páginas /termos e /privacidade do site). Mudar a data quando o texto mudar:
 * o registo grava, na auditoria, a versão que cada empresa aceitou.
 */
export const LEGAL_VERSION = '2026-10-13';
//# sourceMappingURL=legal.js.map